import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import FiscContratosService from '../../../../services/fiscContratos';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [servidor, setServidor] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [ano, setAno] = useState("");
    const [objeto, setObjeto] = useState("");
    const [referencia, setReferencia] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchFiscais()
            setServidor("")
            setSecretaria("")
            setAno("")
            setObjeto("")
            setReferencia("")
        } else {
            var response = await FiscContratosService.buscar(query)
            if (response.data.length >= 1) {
                props.setFiscais(response.data)
                props.setVazio(false)
                setServidor("")
                setSecretaria("")
                setAno("")
                setObjeto("")
                setReferencia("")
            } else {
                props.setVazio(true)
                setServidor("")
                setSecretaria("")
                setAno("")
                setObjeto("")
                setReferencia("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (servidor) prepQuery = prepQuery + `&servidor=${encodeURI(servidor)}`;
        if (objeto) prepQuery = prepQuery + `&objeto=${encodeURI(objeto)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        if (referencia !== "false" && referencia != "false" && referencia !== "") prepQuery = prepQuery + `&referencia=${encodeURI(referencia)}`;
        if (ano !== "false" && ano != "false" && ano !== "") prepQuery = prepQuery + `&ano=${encodeURI(ano)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                        <Col lg={8}>
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="servidor">
                                        <FloatingLabel
                                            label="Servidor"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="servidor"
                                                value={servidor}
                                                onChange={e => setServidor(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="Plataforma">
                                        <FloatingLabel
                                            label="Secretarias"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="Secretarias"
                                                name="secretaria"
                                                onChange={e => setSecretaria(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                {props.secs.map((sec) =>
                                                    <option value={sec.secretaria}>{sec.secretaria}</option>
                                                )}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="objeto">
                                        <FloatingLabel
                                            label="Objeto"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="objeto"
                                                value={objeto}
                                                onChange={e => setObjeto(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="Referencia">
                                        <FloatingLabel
                                            label="Referência"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="referencia"
                                                name="referencia"
                                                onChange={e => setReferencia(e.target.value)}
                                            >
                                                <option>TODAS</option>
                                                <option value="1º Semestre">1º Semestre</option>
                                                <option value="2º Semestre">2º Semestre</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="Ano">
                                        <FloatingLabel
                                            label="Ano"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="ano"
                                                name="ano"
                                                onChange={e => setAno(e.target.value)}
                                            >
                                                <option>TODOS</option>
                                                <option value="2025">2025</option>
                                                <option value="2024">2024</option>
                                                <option value="2023">2023</option>
                                                <option value="2022">2022</option>
                                                <option value="2021">2021</option>
                                                <option value="2020">2020</option>
                                                <option value="2019">2019</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/contratos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.fiscais} nome={"FiscaisContratos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#54b2c850-e331-4b8f-bce0-866020944cea" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
